import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  GridRow,
  GridCell,
} from "../../AddEditInvoice.styled";
import "../../AddEditInvoice.scss";

const ServiceHeader = ({ t, column, page }) => {
  return (
    <GridRow
      column={column}
      padding="0px 10px"
      background="#fff"
      margin="20px 0 0 0"
      gap="0"
    >
      <GridCell
        color="#333"
        fontWeight="700"
        fontSize="16px"
        padding="8px 12px"
      >
        {" "}
      </GridCell>
      {page !== "view" && (
        <GridCell
          color="#333"
          fontWeight="700"
          fontSize="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            borderLeft: "1px solid #b7c9df",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div>{t("CLIENT_INVOICING_SERVICES_REALISED")}</div>

            <div
              style={{
                fontSize: "11px",
                fontStyle: "italic",
                fontWeight: "400",
              }}
            >
              {t("CLIENT_INVOICING_SERVICES_QUANTITY_FROM_SUMMARIES")}
            </div>
          </div>
        </GridCell>
      )}
      <GridCell
        color="#333"
        fontWeight="700"
        fontSize="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          borderLeft: "1px solid #b7c9df",
        }}
      >
        {t("CLIENT_INVOICING_SERVICES_QUANTITY")}
      </GridCell>
      <GridCell
        color="#333"
        fontWeight="700"
        fontSize="16px"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        style={{
          borderLeft: "1px solid #b7c9df",
          paddingRight: "14px",
        }}
      >
        {t("CLIENT_INVOICING_SERVICES_TOTAL")}
      </GridCell>
    </GridRow>
  );
};

ServiceHeader.propTypes = {
  isEditMode: PropTypes.bool,
  page: PropTypes.string,
};

ServiceHeader.defaultProps = {
  isEditMode: false,
  page: "create"
};

export default withTranslation()(ServiceHeader);
